import { render, staticRenderFns } from "./CallControlls.vue?vue&type=template&id=96e4417c"
import script from "./CallControlls.vue?vue&type=script&lang=js"
export * from "./CallControlls.vue?vue&type=script&lang=js"
import style0 from "./CallControlls.vue?vue&type=style&index=0&id=96e4417c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports